<template>
  <blank-view>
    <div
      slot="action"
      style="display: flex; align-items: center; justify-content: space-between"
    >
      <div>
        <a-button v-acl="'page_ops_settings_save'" :loading="loading" type="primary" style="margin-right: 8px" @click="save">
          {{$t('save')}}
        </a-button>
      </div>
    </div>
    <div style="height: 100%; padding: 0 16px">
      <div class="content-box">
        <div class="content-left">
          <a-icon type="solution" class="content-left-icon" />
          <div>{{$t('page_ops_work_record_status_distribute')}}</div>
        </div>
        <div class="content-right">
          <div class="Distribute-box">
            <div class="content-right-info-box">
              <div class="content-right-info-box-title">{{$t('page_ops_settings_timeout_reminder_time')}}：</div>
              <a-input-number
                style="width: 165px"
                :min="0"
                v-model="workRecordSetting.distributionRemindDate"
              />
              <a-select
                show-search
                optionFilterProp="children"
                style="width: 165px"
                v-model="workRecordSetting.distributionRemindDateUnit"
              >
                <a-select-option
                  :value="item.dictKey"
                  v-for="(item, index) in timeUnitDictList"
                  :key="index"
                >
                  {{ item.dictValue }}
                </a-select-option>
              </a-select>
            </div>
            <div class="content-right-info-checkbox">
              <div class="content-right-info-box-title">{{$t('page_ops_settings_distribute_post')}}：</div>
              <a-checkbox-group class="content-right-info-box-body"
                v-model="workRecordSetting.distributionPostList"
                :options="postOptions"
              />
            </div>
            <div class="content-right-info-checkbox">
              <div class="content-right-info-box-title">{{$t('page_ops_settings_is_assigned_users')}}：</div>
              <a-radio-group
                :options="radioOptions"
                v-model="distributionRadioValue" 
              />
            </div>
            <a-checkbox-group class="checkbox-class" :options="distributionOptions"  v-show="distributionRadioValue" v-model="distributionCheckValue" />

            <div class="out-time-box">
              <div class="out-time-box-title">{{$t('page_ops_settings_timeout_processing_rules')}}</div>
              <div class="content-right-info-box">
                <div class="content-right-info-box-title">{{$t('page_ops_settings_timeout_processing_time')}}：</div>
                <a-input-number
                  style="width: 165px"
                  :min="0"
                  v-model="workRecordSetting.timeOutRelayDate"
                />
                <a-select
                  style="width: 165px"
                  show-search
                  optionFilterProp="children"
                  v-model="workRecordSetting.timeOutRelayDateUnit"
                >
                  <a-select-option
                    :value="item.dictKey"
                    v-for="(item, index) in timeUnitDictList"
                    :key="index"
                  >
                    {{ item.dictValue }}
                  </a-select-option>
                </a-select>
              </div>
              <div class="content-right-info-checkbox">
                <div class="content-right-info-box-title">{{$t('page_ops_settings_timeout_processing_post')}}：</div>
                <div>
                <a-checkbox-group class="content-right-info-box-body"
                  v-model="workRecordSetting.timeOutDistributionPostList"
                  :options="postOptions"
                />
                </div>
              </div>
             
            </div>
          </div>
        </div>
      </div>
      <div class="content-box">
        <div class="content-left">
          <a-icon type="reconciliation" class="content-left-icon" />
          <div>{{$t('page_ops_work_record_status_handle')}}</div>
        </div>
        <div class="content-right">
          <div class="Distribute-box">
            <div class="content-right-info-box">
              <div class="content-right-info-box-title">{{$t('page_ops_settings_timeout_reminder')}}：</div>
              <a-input-number
                style="width: 165px"
                :min="0"
                v-model="workRecordSetting.processRemindDate"
              />
              <a-select
                show-search
                optionFilterProp="children"
                v-model="workRecordSetting.processRemindDateUnit"
                style="width: 165px"
              >
                <a-select-option
                  :value="item.dictKey"
                  v-for="(item, index) in timeUnitDictList"
                  :key="index"
                >
                  {{ item.dictValue }}
                </a-select-option>
              </a-select>
            </div>
            <div class="content-right-info-checkbox">
              <div class="content-right-info-box-title">{{$t('page_ops_settings_handel_post')}}：</div>
              <a-checkbox-group class="content-right-info-box-body"
                v-model="workRecordSetting.processPostList"
                :options="postOptions"
              />
            </div>
              <div class="content-right-info-checkbox">
                <div class="content-right-info-box-title">{{$t('page_ops_settings_is_assigned_users')}}：</div>
                <a-radio-group
                  :options="radioOptions"
                  v-model="handleRadioValue" 
                />
              </div>
              <a-checkbox-group class="checkbox-class" :options="handleOptions"  v-show="handleRadioValue" v-model="handleCheckValue" />
          </div>
        </div>
      </div>
      <div class="content-box">
        <div class="content-left">
          <a-icon type="audit" class="content-left-icon" />
          <div>{{$t('page_ops_work_record_status_audit')}}</div>
        </div>
        <div class="content-right">
          <div class="Distribute-box">
            <div class="content-right-info-box">
              <div class="content-right-info-box-title">{{$t('page_ops_settings_timeout_reminder')}}：</div>
              <a-input-number
                style="width: 165px"
                :min="0"
                v-model="workRecordSetting.auditRemindDate"
              />
              <a-select
                style="width: 165px"
                show-search
                optionFilterProp="children"
                v-model="workRecordSetting.auditRemindDateUnit"
              >
                <a-select-option
                  :value="item.dictKey"
                  v-for="(item, index) in timeUnitDictList"
                  :key="index"
                >
                  {{ item.dictValue }}
                </a-select-option>
              </a-select>
            </div>
            <div class="content-right-info-checkbox">
              <div class="content-right-info-box-title">{{$t('page_ops_settings_audit_post')}}：</div>
              <a-checkbox-group class="content-right-info-box-body"
                v-model="workRecordSetting.auditPostList"
                :options="postOptions"
              />
            </div>
             <div class="content-right-info-checkbox">
                  <div class="content-right-info-box-title">{{$t('page_ops_settings_is_assigned_users')}}：</div>
                  <a-radio-group
                    :options="radioOptions"
                    v-model="checkRadioValue" 
                  />
            </div>
            <a-checkbox-group class="checkbox-class" :options="checkOptions"  v-show="checkRadioValue" v-model="checkCheckValue" />
          </div>
        </div>
      </div>
      <div class="content-box">
        <div class="content-left">
          <a-icon type="reconciliation" class="content-left-icon" />
          <div>账号分配</div>
        </div>
        <div class="content-right" style="flex: 1;">
          <div style="display: flex;">
            <ml-table
              style="width: 300px;"
              :columns="accountColumns"
              :dataSource="accountData"
              size="small"
              rowKey="id"
              :pagination="false"
              :scroll="{ y: 400 }"
              :selectRowKey="selectedRow && selectedRow.id"
              :customRow="
                (row) => ({
                  on: {
                    click: () => {
                      this.clickRow(row)
                    }
                  }
                })
              "
            >
            <template slot="account" slot-scope="text, record">
              <div style="display: flex;justify-content: space-between; align-items: center">
                <div>{{ `${text}(${record.name})` }}</div>
                <a-button style="padding:0px;height: 16px; line-height: 16px;" type="link" v-if="selectedRow.id === record.id" @click="bindCustomer">关联客户</a-button>
              </div>
            </template>
            </ml-table>
            <div style="flex: 1;margin-left: 8px;">
              <ml-table
              style="width: 100%;"
              :columns="customerColumn"
              :dataSource="customerData"
              size="small"
              rowKey="id"
              :pagination="false"
              :scroll="{ y: 400 }"
            >
            </ml-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CustomerModal ref="customerModalRef" @update="getBindCustomers" />
  </blank-view>
</template>

<script>
import {
  MasterlinkUserServiceProxy
} from "@/service-proxies/app-v2/user.service-proxies";
import {DictServiceProxy,PostServiceProxy} from "@/service-proxies/app-v2/system.service-proxies";
import {WorkRecordSettingServiceProxy} from "@/service-proxies/app-v2/work-record.service-proxies";
import { CustomerServiceProxy } from '@/service-proxies/app-v2/masterlink-cps-client.service-proxies';
const dictServiceProxy = new DictServiceProxy();
const postServiceProxy = new PostServiceProxy();
const workRecordSettingServiceProxy = new WorkRecordSettingServiceProxy();
const MasterlinkUserService = new MasterlinkUserServiceProxy();
const customerService = new CustomerServiceProxy()
import CustomerModal from './components/CustomerModal.vue';
export default {
  components: { CustomerModal },
  data() {
    return {
      postOptions: [],
      workRecordSetting: {},
      timeUnitDictList: [],
      loading: false,
      radioOptions: [{
      label: this.$t('yes'),
      value: 1
      },{
        label: this.$t('no'),
        value: 0
      }],
      distributionRadioValue: 0,
      handleRadioValue:0,
      checkRadioValue: 0,
      distributionOptions: [],
      handleOptions: [],
      checkOptions: [],
      distributionCheckValue: [],
      handleCheckValue: [],
      checkCheckValue: [],

      selectedRow: {},
      accountData: [],
      accountColumns: [
        {
          title: '账户',
          dataIndex: 'account',
          key: 'account',
          ellipsis: true,
          scopedSlots: { customRender: 'account' }
        },
      ],
      
      customerData: [],
    };
  },
  created() {
    new Promise((resolve) => {
      this.getTimeUnitDict()
      this.getPost()
      resolve('success')
      }).then((res) => {
        this.getData()
      });
    this.getAccount();
    
  },
  computed: {
    customerColumn() {
      const title = this.selectedRow.account + ' 账号关联的客户列表';
      return [
        {
          title,
          dataIndex: 'customerName',
          key: 'customerName',
          ellipsis: true,
          scopedSlots: { customRender: 'customerName' }
        }
      ]
    },
  },
  watch: {
    distributionRadioValue: {
      handler(val) {
       if (!val) {
         this.distributionCheckValue = []
       }
      },
      immediate: true
    },
    'workRecordSetting.distributionPostList' : {
      handler(val) {
       if (val && val.length > 0) {
         this.getAssignRecord(val.join(','), 1)
       }
      },
      immediate: true
    },
    handleRadioValue: {
      handler(val) {
       if (!val) {
         this.handleCheckValue = []
       }
      },
      immediate: true
    },
    'workRecordSetting.processPostList' : {
      handler(val) {
       if (val && val.length > 0) {
         this.getAssignRecord(val.join(','), 2)
       }
      },
      immediate: true
    },
    checkRadioValue: {
      handler(val) {
       if (!val) {
         this.checkCheckValue = []
       }
      },
      immediate: true
    },
    'workRecordSetting.auditPostList' : {
      handler(val) {
       if (val && val.length > 0) {
         this.getAssignRecord(val.join(','), 3)
       }
      },
      immediate: true
    },
  },
  methods: {
    clickRow(row) {
      this.selectedRow = row;
      this.getBindCustomers();
    },
    bindCustomer() {
      const ids = this.customerData.map(v=>v.customerId);
      this.$refs['customerModalRef'].onShow(this.selectedRow, ids);
    },
    getBindCustomers() {
      customerService.getCustomerUserRelation(this.selectedRow.id).then(data=>{
        this.customerData = data.data.customerUser;
      })
    },
    getAccount() {
      console.log(MasterlinkUserService);
      MasterlinkUserService.page(1,'','',-1).then((res) => {
        if (res.data.records) {
          this.accountData = res.data.records;
          this.selectedRow = res.data.records[0];
          this.getBindCustomers();
        }
      });
    },
    async getTimeUnitDict() {
      let res = await dictServiceProxy.dictionary("time_units")
      this.timeUnitDictList = res.data || []
    },
    getAssignRecord(postCodes, postType) {
      workRecordSettingServiceProxy.getAssignedUsers(postCodes, postType).then(res => {
        if (postType === 1) {
          this.distributionOptions = []
          res.users.forEach(re => {
            this.distributionOptions.push({
              label: re.name,
              value: re.id
            })
          })
        } else if (postType === 2) {
          this.handleOptions = []
          res.users.forEach(re => {
            this.handleOptions.push({
              label: re.name,
              value: re.id
            })
          })
        } else if (postType === 3) {
          this.checkOptions = []
          res.users.forEach(re => {
            this.checkOptions.push({
              label: re.name,
              value: re.id
            })
          })
        }
      })  
    },  
    async getPost() {
      let res = await postServiceProxy.select()
      this.postOptions = res.data.map((item) => {
        return { label: item.postName, value: item.postCode }
      });
    },
    initCheck(data) {
      if (data.auditUsers && data.auditUsers.length > 0) {
        this.checkRadioValue = 1
        this.checkCheckValue = data.auditUsers
      }
      if (data.processUsers && data.processUsers.length > 0) {
        this.handleRadioValue = 1
        this.handleCheckValue = data.processUsers
      }
      if (data.distributionUsers && data.distributionUsers.length > 0) {
        this.distributionRadioValue = 1
        this.distributionCheckValue = data.distributionUsers
      }

    },
    getData() {
      workRecordSettingServiceProxy.page().then((res) => {
        this.initCheck(res)
        // 初始化数据
        res.timeOutDistributionPostList = (res.timeOutDistributionPost||'').split(',')
        res.processPostList = (res.processPost||'').split(',')
        res.distributionPostList = (res.distributionPost||'').split(',')
        res.auditPostList = (res.auditPost||'').split(',')
        this.workRecordSetting = res
      }).catch((err)=>{
        const data ={
          distributionRemindDate: 1,
          timeOutRelayDate: 30,
          processRemindDate: 1,
          auditRemindDate: 1,
          distributionRemindDateUnit: this.timeUnitDictList.length?this.timeUnitDictList[0].dictKey:'',
          timeOutRelayDateUnit: this.timeUnitDictList.length?this.timeUnitDictList[0].dictKey:'',
          processRemindDateUnit: this.timeUnitDictList.length?this.timeUnitDictList[0].dictKey:'',
          auditRemindDateUnit: this.timeUnitDictList.length?this.timeUnitDictList[0].dictKey:'',
          timeOutDistributionPostList: [],
          processPostList: [],
          distributionPostList: [],
          auditPostList: []
        }
        this.$nextTick(()=>{
          this.workRecordSetting = data
        })
      }).finally(() =>{
        this.loading = false
      });
    },
    save() {
      if(this.workRecordSetting.distributionRemindDate < 0 || !this.workRecordSetting.distributionRemindDateUnit){
         this.$message.error(this.$t('page_ops_settings_distribute_timeout_reminder_time_required'))
         return
      }
      if(!this.workRecordSetting.distributionPostList.length){
         this.$message.error(this.$t('page_ops_settings_distribute_post_required'))
         return
      }
      this.workRecordSetting.distributionPost = this.workRecordSetting.distributionPostList.join(',')
      if(this.workRecordSetting.timeOutRelayDate < 0 || !this.workRecordSetting.timeOutRelayDateUnit){
         this.$message.error(this.$t('page_ops_settings_distribute_timeout_processing_time_required'))
         return
      }
      if(!this.workRecordSetting.timeOutDistributionPostList.length){
         this.$message.error(this.$t('page_ops_settings_distribute_timeout_processing_post_required'))
         return
      }
      this.workRecordSetting.timeOutDistributionPost = this.workRecordSetting.timeOutDistributionPostList.join(',')
      if(this.workRecordSetting.processRemindDate < 0 || !this.workRecordSetting.processRemindDateUnit){
         this.$message.error(this.$t('page_ops_settings_handle_timeout_reminder_time_required'))
         return
      }
      if(!this.workRecordSetting.processPostList.length){
         this.$message.error(this.$t('page_ops_settings_handle_post_required'))
         return
      }
      this.workRecordSetting.processPost = this.workRecordSetting.processPostList.join(',')
      if(this.workRecordSetting.auditRemindDate < 0 || !this.workRecordSetting.auditRemindDateUnit){
         this.$message.error(this.$t('page_ops_settings_audit_timeout_reminder_time_required'))
         return
      }
      if(!this.workRecordSetting.auditPostList.length){
         this.$message.error(this.$t('page_ops_settings_audit_post_required'))
         return
      }
      this.workRecordSetting.auditPost = this.workRecordSetting.auditPostList.join(',')
      if(this.loading){return}
      this.loading = true

      this.workRecordSetting.auditUsers = this.checkCheckValue
      this.workRecordSetting.distributionUsers = this.distributionCheckValue
      this.workRecordSetting.processUsers = this.handleCheckValue

      workRecordSettingServiceProxy.submit(this.workRecordSetting).then((res)=>{
        this.$message.success('success')
        this.getData()
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-box {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid #d8d8d8;
}
.content-left {
  width: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #4a90e2;
  line-height: 28px;
  flex-direction: column;
  flex-wrap: nowrap;
  font-weight: bold;
  padding: 40px 0;
  &-icon {
    color: #4a90e2;
    font-size: 57px;
    margin-bottom: 13px;
  }
}
.content-right {
  height: 100%;
  padding: 16px 0;
  .out-time-box {
    width: 660px;
    border: 1px solid #d8d8d8;
    &-title {
      background-color: #f8f8f8;
      padding: 8px 16px;
      border-bottom: 1px solid #d8d8d8;
      font-weight: bold;
      margin-bottom: 12px;
    }
  }
  .content-right-info-box {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-bottom: 12px;
    &-checkbox {
      align-items: flex-start;
    }
  }

  .content-right-info-checkbox {
    display: flex;
    align-items: center;
    align-items: flex-start;
    padding-bottom: 12px;
  }

  .content-right-info-box-title {
    width: 150px;
    text-align: right;
  }
  .content-right-info-box-body {
    width: 510px;
    display: flex;
    flex-wrap: wrap;
    /deep/ .ant-checkbox-group-item {
      width: 30%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}

.checkbox-class{
  width: 500px;
  margin-left: 150px;
  margin-bottom: 20px;
}
</style>
